module.exports = __webpack_public_path__ + "is-open.6cc5958a7778eac18679.svg";